import { addToFormArrayAction } from '../../actions/schemaActions';

const addToFormArray = (newItem, component) => {
  component.props.dispatch(
    addToFormArrayAction(component.props.id, newItem)
  );
};

export default addToFormArray;
